<template>
    <v-dialog v-model="child_dialog" max-width="80%">
        <app-card>
            <app-section-loader :status="form_loader"></app-section-loader>
            <h4>PHIẾU THU TIỀN MẶT</h4>
            <p v-if="!is_review_only" class="fs-14 grey--text">Tạo phiếu thu tiền mặt</p>
            <v-form ref="form">
                <v-container fluid>
                    <v-layout row wrap justify-center>
                        <v-flex xs12>
                            <h5 v-if="is_review_only">Mã phiếu: {{ form.receipt_id }}</h5>
                            <h5>Số lượng phiếu đã chọn: {{ form.list_receipts.length }}</h5>
                            <h5>Tổng số tiền thu từ các phiếu: {{ form.amount | formatNumber }} VND</h5>
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-select label="Tòa nhà" :disabled="true" v-model="form.building" :items="list_building"
                                prepend-icon="domain" :rules="[rules.required]" required></v-select>
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-menu :close-on-content-click="false" v-model="menu_receipt_date_collected"
                                :nudge-right="40" lazy transition="scale-transition" offset-y full-width
                                min-width="290px">
                                <v-text-field slot="activator" v-model="form.date_collected" label="Ngày thu"
                                    :disabled="loading.submit || is_review_only" prepend-icon="event" readonly
                                    :rules="[rules.required]"></v-text-field>
                                <v-date-picker locale="vi-VI" v-model="form.date_collected"
                                    @input="menu_receipt_date_collected = false"></v-date-picker>
                            </v-menu>
                        </v-flex>

                        <v-flex xs12 md12>
                            <v-text-field label="Ghi chú" :disabled="loading.submit || is_review_only" v-model="form.note"
                                prepend-icon="event_note"></v-text-field>
                        </v-flex>
                        <v-flex xs12 v-if="alert.show">
                            <v-alert :value="alert.show" :type="alert.type" outline>{{ alert.text }}</v-alert>
                        </v-flex>
                        <v-flex xs12 md12>
                            <v-card>
              <v-data-table :headers="headers" :items="list_receipts" :rows-per-page-items="rowPerPage">
                <template v-slot:items="props">
                  <tr>
                    <td class="text-center text-no-wrap" @click.stop>
                      {{ props.index + 1 }}
                    </td>
                    <td class="text-center text-no-wrap" @click.stop>
                      {{ props.item.receipt_id }}
                    </td>
                    <td class="text-center text-no-wrap" @click.stop>
                      {{ props.item.date_action | formatTimeServer }}
                    </td>
                    <td class="text-right text-no-wrap" @click.stop>
                      {{ props.item.collected_amount || props.item.deposit_amount | formatCurrency }}
                    </td>
                    <td class="text-right text-no-wrap" @click.stop>
                      {{ props.item.amount | formatCurrency }}
                    </td>
                    <td class="text-right text-no-wrap" @click.stop>
                      {{ props.item.balance | formatCurrency }}
                    </td>
                    <td class="text-center text-no-wrap" @click.stop>
                      {{ props.item.note }}
                    </td>
                    <td class="text-center text-no-wrap" @click.stop>
                      {{ props.item.room_id }}
                    </td>
                  </tr>
                </template>
                <template #no-data>
                  Chưa có thông tin
                </template>
              </v-data-table>
            </v-card>
        </v-flex>
                    </v-layout>
                </v-container>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn v-if="!is_review_only" :disabled="loading.submit" @click="cancelInput">Trở về</v-btn>
                    <v-btn  v-if="!is_review_only" :loading="loading.submit" :disabled="loading.submit" @click="submit" color="primary">Tạo phiếu thu tiền mặt</v-btn>
                </v-card-actions>
            </v-form>
        </app-card>
    </v-dialog>
</template>

<script>
import api from "Api";
import {
    buildParamQuery,
} from "Helpers";
import { list_building, CASH_ACCOUNT_ID_TO_BUILDING_MAPPING } from "Constants/db-config";
import { Wallet } from "Components/Form";

export default {
    name: "dialog-tao-phieu-thu-tien-mat",
    props: {
        dialog: Boolean,
        collected_amount: Number,
        chosen_wallet_account_id: Number,
        list_receipts: Array,
        is_review_only: Boolean,
        review_receipt: Object,
    },
    components: {
        Wallet
    },
    data() {
        return {
            menu_receipt_date_collected: false,
            child_dialog: false,
            form_loader: false,
            menu_month_picker: false,
            menu_date_collected: false,
            rules: {
                required: value => !!value || "Vui lòng điền thông tin này."
            },
            form: {
                date_collected: undefined,
                note: "",
                amount: 0,
                building: '',
                wallet_account_id: 0,
                list_receipts: [],
            },
            list_building,
            loading: {
                submit: false
            },
            alert: {
                show: false,
                text: "",
                type: "error"
            },
            headers: [
        {
          text: "Số thứ tự",
          align: "center",
          sortable: false,
          value: "index",
        },
        {
          text: "Số chứng từ",
          align: "center",
          sortable: true,
          value: "receipt_id",
        },
        {
          text: "Ngày",
          align: "center",
          sortable: true,
          value: "date_action",
        },
        {
          text: "Số tiền thu",
          align: "center",
          sortable: true,
          value: "collected_amount",
        },
        {
          text: "Số tiền chi",
          align: "center",
          sortable: true,
          value: "amount",
        },
        {
          text: "Số dư",
          align: "center",
          sortable: true,
          value: "balance",
        },
        {
          text: "Nội dung chi tiết",
          align: "center",
          sortable: true,
          value: "note",
        },
        {
          text: "Số phòng",
          align: "center",
          sortable: true,
          value: "room_id",
        },
      ],
      rowPerPage: [20, 50, 100, { text: "Tất cả", value: -1 }],
        };
    },
    computed: {
        rooms() {
            return this.$store.state.app.rooms;
        },
        room_ids() {
            return this.rooms.filter(
                room => room.building === this.form.building
            );
        },
    },
    watch: {
        dialog() {
            this.child_dialog = this.dialog;

            if (this.dialog) {
                const DEFAULT_FORM_VALUES = {
                    date_collected: undefined,
                    note: "",
                    amount: this.collected_amount,
                    building: CASH_ACCOUNT_ID_TO_BUILDING_MAPPING[this.chosen_wallet_account_id],
                    wallet_account_id: this.chosen_wallet_account_id,
                    list_receipts: this.list_receipts,
                };

                this.form = this.is_review_only ? { ...this.review_receipt, date_collected: this.review_receipt.date_collected.substr(0, 10) } : DEFAULT_FORM_VALUES;

                this.formatMoney();
            }
        },
        child_dialog(nv) {
            this.$emit("changeDialogState", nv);
        },
    },
    methods: {
        formatMoney: function () {
            let amount = this.form.amount;
            amount = amount
                ? amount
                    .toString()
                    .replace(/,/g, "")
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                : 0;
            this.form.amount = amount;
        },
        cancelInput() {
            this.dialog = false;
            this.$refs.form.reset();
        },
        submit: async function () {
            if (!this.$refs.form.validate()) {
                swal.fire("Lỗi", "Vui lòng điền đầy đủ thông tin", "error");
            }

            this.loading = true;

            const postData = {
                ...this.form,
                date_collected: new Date(this.form.date_collected),
                amount: Number(
                    this.form.amount.replace(/,/g, "")
                )
            };

            const data = await api.createReceiptCash(postData);

            this.loading = false;

            if (data.status === 200) {
                this.child_dialog = false;
                this.cancelInput();
                this.$emit("resetTable");
                swal.fire("Thành công", data.data.message, "success");
            } else swal.fire("Lỗi", data.message, "error");
        },
    }
};
</script>

<style></style>